import React, { useState, useContext } from "react";
import Context from "../Context";
import Config from "../config.json";
import { useParams } from "react-router";
import { Row, Col, Card } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import Statics from "../Statics";
import { useEffect } from "react";
export default () => {
  const context = useContext(Context);
  const { access_token, expires_at } = useParams();
  const data = JSON.parse(
    new URLSearchParams(document.location.search).get("data")
  );

  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: Config.title + " | تماس با ما",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  };
  const [loading, set_loading] = useState(Statics.NOT_LOADED);
  const fetchProfile = () => {
    set_loading(Statics.LOADING);
    context.ApiDriver.access_token = access_token;
    context.ApiDriver.expires_at = expires_at;
    context.ApiDriver.fetchProfile(
      (response) => {
        context.cookie.set("pajoohyar_access_token", access_token, {
          path: "/",
        });
        context.cookie.set("pajoohyar_expires_at", expires_at, {
          path: "/",
        });
        context.cookie.set("pajoohyar_profile", JSON.stringify(response), {
          path: "/",
        });
        context.profile = response;
        
        set_loading(Statics.LOADED);
        setTimeout(() => {
          if (data && data.redirect_url) window.location = data.redirect_url;
          else window.location = "/";
        }, 1500);
      },
      (error) => {
        console.log(error);
      }
    );
  };
  useEffect(fetchProfile, []);
  if (loading === Statics.NOT_LOADED || loading === Statics.LOADING)
    return (
      <DocumentMeta {...page_meta}>
        <Row className="justify-content-center" style={{ minHeight: 550 }}>
          <Col>
            <Card style={{ marginTop: 150, marginBottom: 30 }}>
              <Card.Body style={{ margin: "auto" }}>
                در حال دریافت اطلاعات...
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </DocumentMeta>
    );
  if (loading === Statics.CAUSED_ERROR) {
    return (
      <DocumentMeta {...page_meta}>
        <Row className="justify-content-center" style={{ minHeight: 550 }}>
          <Col>
            <Card>
              <Card.Body>خطایی رخ داده است. لطفا دوباره تلاش کنید.</Card.Body>
            </Card>
          </Col>
        </Row>
      </DocumentMeta>
    );
  }
  if (loading === Statics.LOADED) {
    return (
      <DocumentMeta {...page_meta}>
        <Row className="justify-content-center" style={{ minHeight: 550 }}>
          <Col>
            <Card style={{ marginTop: 150, marginBottom: 30 }}>
              <Card.Body style={{ margin: "auto" }}>
                ورود با موفقیت انجام شد. در حال انتقال به صفحه اصلی...
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </DocumentMeta>
    );
  }
};
